const flex = {display: 'flex' as 'flex'}

export default flex
